module.exports = __webpack_public_path__ + "img/Weapon_156.4638090b.png";